<template>
  <b-modal
    ref="bModal"
    :title="$t('component.printLabelsModal.templateList')"
    centered
    modal-class="templates-list"
    static
    size="lg"
    qa="templates-list-modal"
  >
    <b-row class="py-3 px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <vt-grid
          pagination
          class="templates-grid"
          :grid-options="gridOptions"
          :row-data="rowData"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <!-- TODO: Los siguientes 2 aparecen cuando se guarda sobre una plantilla existente -->
          <b-button
            v-if="selectedRows.length === 1"
            size="sm"
            class="btn__outline mr-2"
            @click="deleteTemplates([gridApi.getSelectedRows()[0].id])"
          >
            <i
              class="fal fa-trash-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('global.delete') }}
          </b-button>
          <b-button
            v-if="selectedRows.length === 1"
            size="sm"
            class="btn--primary"
            @click="selectTemplate"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import i18n from '@/lang/i18n'
import bacthPrintingDashboardServices from '@/api/resources/common/batchPrintingDashboardServices'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'TemplatesList',
    components: {
        VtGrid
    },
    data() {
        return {
            isActive: false,
            selected: null,
            selectedRows: [],
            columnDefs: [
                { type: 'customCheckbox' },
                {
                    type: 'text',
                    headerName: i18n.t('component.printLabelsModal.labelName'),
                    colId: 'title',
                    field: 'title',
                    width: 150,
                    minWidth: 140,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('component.printLabelsModal.labelDescription'),
                    colId: 'description',
                    field: 'description',
                    width: 150,
                    minWidth: 280,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('component.printLabelsModal.printUser'),
                    colId: 'userapp.fullName',
                    field: 'userapp.fullName',
                    flex: 1,
                    width: 200,
                    minWidth: 100,
                    suppressSizeToFit: true
                }
            ],
            rowData: []
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        }
    },
    methods: {
        selectTemplate() {
            this.$emit('selectTemplate', this.gridApi.getSelectedRows()[0])
            this.hide()
        },
        show(templates) {
            this.assignTemplateRowData(templates)
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        getContextMenuItems(params) {
            return [
                {
                    name: this.$tc('component.printLabelsModal.deleteTemplate', !this.gridApi.getSelectedRows().length || this.gridApi.getSelectedRows().length === 1 ? 1 : 2),
                    action: () => {
                        if (this.gridApi.getSelectedRows().length) {
                            const templateIds = this.selectedRows.map((template) => template.id)
                            this.deleteTemplates(templateIds)
                        } else {
                            this.deleteTemplates([params?.node.data.id])
                        }
                    }
                },
                {
                    name: this.$t('Aplicar plantilla'),
                    action: () => {
                        this.$emit('selectTemplate', params?.node.data)
                        this.hide()
                    }
                }
            ]
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
        },
        assignTemplateRowData(templates) {
            this.rowData = templates
        },
        async deleteTemplates(templateIds) {
            const [err] = await this.toCall(bacthPrintingDashboardServices.deleteTemplateBatch(this.labId, templateIds))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showToastSuccessGlobal(this.$t('component.printLabelsModal.templateDeleted'))
            this.$emit('onTemplatesDeleted', templateIds)
        }
    }
}

</script>

<style lang="scss">
    .templates-list .modal-body {
        padding: 20px 10px;
    }

    .templates-list .templates-grid {
        height: calc(100vh - 450px);
    }
</style>

<style lang="scss" scoped>
    .templates-list span {
        font-size: font-size(very-normal);
    }
</style>
